


























































































import {Component, Ref, Vue} from 'vue-property-decorator';
import CourseCanvas from '@/views/media/course/components/course-canvas.vue';
import CourseFilter from '@/views/media/course/components/course-filter.vue';
import CourseStyle from '@/views/media/course/components/course-style.vue';
import moment from 'moment';
import {CourseActionTypes} from '@/store/actions/types';
import {CourseItemData} from '@/views/media/course/components/course-item';
import {COURSE_STYLE_TABS_KEYS} from '@/views/media/course/components/course-style';
import {
  FilterOptionMaps,
  FilterValues,
  ShowOptionMaps,
  TemplateOptions
} from '@/views/media/course/components/course-filter';
import {COURSE_ID, COURSE_TYPES} from '@/maps/enum/course';

/**默认数据*/
const courseDefault = {
  phoneNumber: '15918874225',
  tipsList: [],
  updateTime: moment().format('YYYY.MM.DD'),
  title: `体验课`,
  stores: ['华师店', '珠江新城店',  '淘金店', '客村店', '体育西路店', '汉溪长隆店', '越秀公园店'],
  qrcodeStore: true,
  qrcodeMini: true,
  tips: [
    ' 体验课六周年汇演活动价6元1节，新学员可体验1次。',
    ' 可在小程序自助完成预约 ，或在大众点评/美团拍下体验券联系课程顾问办理预约 （预约需提前24小时）。',
    ' 新学员报名芭蕾入门课程（或其他符合程度的课程），可以享受50元的报班优惠。',
    ' 体验课穿运动服、瑜伽服和深色袜子，或自备练功服和舞蹈鞋。',
    ' 软开素质/天鹅肩臂课程，另有多个时间段可选，联系课程顾问获取。'
  ],
  bannerStyle: {
    girl: {transform: 'translateX(0)', filter: 'blur(0px)'},
    floot: {transform: 'translateX(0)', filter: `blur(4px)`},
    dva: {transform: 'translateX(0)', filter: `blur(5px)`},
    leaf: {transform: 'translateX(0)', filter: 'blur(6px)'},
    slope: {transform: 'translateX(0)', filter: 'blur(1px)'}
  },
};


interface BannerStyle {
  transform?: string;
  filter?: string;
}

@Component({
  components: {CourseStyle, CourseFilter, CourseCanvas}
})
export default class CoursePrintView extends Vue {

  @Ref('canvas')
  private canvas!: HTMLElement;

  @Ref('filter')
  private filterComponent!: HTMLElement;

  @Ref('style')
  private styleComponent!: HTMLElement;

  /**显示编辑*/
  private showFilter: boolean = false;
  private showStyle: boolean = false;
  /**下载图片锁*/
  private imageLock: boolean = true;
  /**课程样式*/
  private styleActiveKey: COURSE_STYLE_TABS_KEYS = COURSE_STYLE_TABS_KEYS.GLOBAL;
  /**标题*/
  private title: string = courseDefault.title;
  private titleSize: number = 20;

  /**节点*/
  private nodeMap: Array<string> = [];
  /**表头*/
  private headSize: number = 16;
  /**filter检索栏列表*/
  private filterOptionMaps: FilterOptionMaps | undefined;
  /**filter内容相关*/
  private contentOptionMaps: TemplateOptions = {
    title: courseDefault.title,
    week_label: 'time',
    tips: courseDefault.tips,
    start_time: '',
    update_time: courseDefault.updateTime,
    phone_number: courseDefault.phoneNumber,
    store_list: []
  };
  private shopOptionMaps: ShowOptionMaps = {footer: true, tips: true, store: true, qrcode: true};
  /**课表数据*/
  private courseColorMap: Array<{ name: string; count: number; }> = [];
  private courseHead: Array<string> = [];
  private courseData: Map<string, Map<string, CourseItemData>> = new Map<string, Map<string, CourseItemData>>();
  private courseItemData: CourseItemData = {merge: 1, key: 1};
  /**接口筛选对象*/
  private params = {
    week: [],
    curriculum_id: [],
    alias: '',
    type: [],
    status: 1,
    room_id: [],
    store_id: [],
    begin_date: this.$moment.format('YYYY-MM-DD')
  };
  /**banner样式*/
  private bannerStyle: { girl: BannerStyle; floot: BannerStyle; dva: BannerStyle; leaf: BannerStyle; slope: BannerStyle; } = courseDefault.bannerStyle;
  /**移动位置*/
  private bannerX: number = 0;


  /**指针离开头部*/
  public bannerMouseleave(event: MouseEvent) {
    this.bannerX = 0;
    let banners: any = document.getElementById('course-header')!.children!;
    banners.forEach((item: any, index: number) => {
      item.style.transition = 'all 1s';
    });
    banners.item(1).style.filter = `blur(4px)`;
    banners.item(1).style.transform = `translateX(0px)`;
    banners.item(2).style.filter = `blur(5px)`;
    banners.item(2).style.transform = `translateX(0px)`;
    banners.item(3).style.filter = `blur(6px)`;
    banners.item(3).style.transform = `translateX(0px)`;
    banners.item(4).style.filter = `blur(0px)`;
    banners.item(5).style.filter = `blur(1px)`;
    banners.item(5).style.transform = `translateX(0px)`;

  }

  /**移入*/
  public bannerMouseenter(event: MouseEvent) {
    this.bannerX = event.clientX;
    this.bannerStyle = courseDefault.bannerStyle;
    let banners: any = document.getElementById('course-header')!.children!;
    banners.forEach((item: any) => {
      item.style.transition = 'none';
    });
  }

  /**banner移动*/
  public bannerMousemove(event: MouseEvent) {
    let x = event.clientX - this.bannerX;
    let banners: any = document.getElementById('course-header')!.children!;
    banners.item(1).style.filter = `blur(${Math.abs(x * 10 / 1920 - 4)}px)`;
    banners.item(1).style.transform = `translateX(${x / 10}px)`;
    banners.item(2).style.filter = `blur(${Math.abs(x * 15 / 1920 - 5)}px)`;
    banners.item(2).style.transform = `translateX(${x / 5}px)`;
    banners.item(3).style.filter = `blur(${Math.abs(x * 30 / 1920 + 6)}px)`;
    banners.item(3).style.transform = `translateX(${x / 15}px)`;
    banners.item(4).style.filter = `blur(${Math.abs(x * 5 / 1920)}px)`;
    banners.item(5).style.filter = `blur(${Math.abs(x * 10 / 1920 - 1)}px)`;
    banners.item(5).style.transform = `translateX(${x / 20}px)`;
  }

  /**隐藏filtre*/
  public hideFilter() {
    this.showFilter = false;
  }

  /**显示filter*/
  public showFilterView() {
    this.showFilter = true;
  }

  /**名称修改*/
  public globalNameSave(map: Map<string, string>) {
    this.courseData.forEach((title, title_key, title_map) => {
      if (!title_key) {
        return;
      }
      title.forEach((course, course_key, course_map) => {
        map.forEach((name, name_key) => {   //遍历所有标题选项
          if (course?.course) {
            course.course.forEach((value:any,index,ary)=>{  //时间内course列表中所有名称过滤
              if( value.id == +name_key){
                ary[index]['name'] = name;  //替换名称
              }
            });
          }
        });
        // 刷新课程信息,设置新的key用于渲染
        course_map.set(course_key, Object.assign(course, {key: moment().valueOf()}));
        title_map.set(title_key, course_map);
      });
    });
    this.$set(this.canvas, 'courseData', null);
    this.$set(this.canvas, 'courseData', this.courseData);
  }


  /**二维码状态*/
  public showChange(showOptionMaps: ShowOptionMaps) {
    this.$set(this.canvas, 'showOption', showOptionMaps);
    this.$forceUpdate();
  }

  /**课程点击*/
  public courseClick(data: { week: string; time: string; }) {
    this.showStyle = true;
    this.styleActiveKey = COURSE_STYLE_TABS_KEYS.STYLE;
    this.courseItemData = {course: [], key: moment().valueOf(), merge: 1};
    this.$nextTick(() => {
      this.courseItemData = Object.assign(this.courseData.get(data.week)!.get(data.time), {
        week: data.week,
        merge: 1
      });
      this.$forceUpdate();
    });
  }

  /**课程显示*/
  public courseSwitch(courseItemData: CourseItemData) {
    let map = this.courseData.get(courseItemData.week!);
    courseItemData.key = moment().valueOf();
    map!.set(courseItemData.datetime!, courseItemData);
    this.courseData.set(courseItemData.week!, map!);
    this.$set(this.canvas, 'courseData', Object.assign({}, this.courseData));
    this.courseItemData = courseItemData;
    this.$forceUpdate();
  }


  /**提示修改*/
  public saveTips(tips: Array<string>) {
    this.$set(this.filterComponent, 'contentOptionMap', Object.assign(this.contentOptionMaps, {tips: tips}));
  }

  /**删除提示*/
  public delTips(index: number) {
    if (index == 0) {
      this.contentOptionMaps?.tips?.splice(0, 1);
    } else {
      this.contentOptionMaps?.tips?.splice(index, index);
    }
    this.$forceUpdate();
  }

  /**标题大小改变*/
  public titleSizeChage(size: number) {
    this.titleSize = size;
    this.$forceUpdate();
  }

  /**表头标题大小改变*/
  public headSizeChage(size: number) {
    this.headSize = size;
    this.$forceUpdate();
  }


  /**时间选择*/
  public courseDateChage(date: string) {
    this.params = Object.assign(this.params, {begin_date: date});
  }

  /**更新时间选择*/
  public updateChange(time: string) {
    this.contentOptionMaps.update_time = time;
  }

  /**标题设置*/
  public titleInput(title: string) {
    this.$set(this.canvas, 'contentOptionMap', Object.assign(this.contentOptionMaps, {title: title}));
  }

  /**客服咨询号码*/
  public coursePhoneInput(phone: string) {
    this.contentOptionMaps.phone_number = phone;
  }

  /**星期缩写*/
  public weekLabelChange(labelType: 'day' | 'time') {
    this.$set(this.contentOptionMaps, 'week_label', labelType);
  }


  /**表格生成*/
  public async courseLoad(filterValue: FilterValues,) {
    this.courseData = new Map<string, Map<string, CourseItemData>>();
    this.params = Object.assign(this.params, {
      week: filterValue.week,
      curriculum_id: [
       COURSE_ID.天鹅肩臂,
       COURSE_ID.软开素质,
       COURSE_ID.足尖零基础_短期,
       COURSE_ID.足尖零基础,
       COURSE_ID.天鹅肩臂_短期,
       COURSE_ID.平衡能力提升,
       COURSE_ID.足尖入门,
       COURSE_ID.足尖初级,
       COURSE_ID.精品班
      ],
      type: filterValue.type,
      // status: filterValue.isPut ? 1 : 0,
      status: 1,
      alias: '',
      room_id: filterValue.room,
      semester_id: 18,
      store_id: filterValue.store,
    });
    let data = await this.$store.dispatch(CourseActionTypes.GET_SCREEN_SINGLE, {
      weekUnit: this.contentOptionMaps.week_label,
      type: [COURSE_TYPES.TYPE_SEMESTER_COURSE,COURSE_TYPES.TYPE_SINGLE],
      params: this.params
    });
    this.courseColorMap = data.colorMap || [];
    this.courseHead = data.headerMap;
    this.courseData = data.courseMap;
    this.contentOptionMaps.store_list = courseDefault.stores;
    this.nodeMap = data.nodeMap;
    this.imageLock = false;
    this.$forceUpdate();
  }

  /**获取课程列表样式数据*/
  get courseList() {
    return this.courseData;
  }

  /**全局名称列表获取*/
  get courseNamesMaps() {
    let map: Map<number, string> = new Map<number, string>();
    this.courseData.forEach((value, key) => {
      value.forEach(courseList => {
        courseList.course?.forEach(course => {
          if (!map.has(course.id!)) {
            if (course?.name) {
              map.set(course.id!, course?.name);  //初始化所有默认课程的名称...
            }
          }
        });
      });
    });
    return map;
  }

  get courseTimesMaps() {
    let map: Map<number, { title: string; start_hour: number; end_hour: number; start_min: number; end_min: number; key: number; }> = new Map<number, { title: string, start_hour: number, end_hour: number, start_min: number, end_min: number, key: number }>();
    this.courseData.forEach((value, key) => {
      value.forEach(courseList => {
        courseList.course?.forEach(course => {
          if (!map.has(course.id!)) {
            map.set(course.id!, {
              title: course?.name || '',
              start_min: 0,
              start_hour: 0,
              end_min: 0,
              end_hour: 0,
              key: course.id!
            });
          }
        });
      });
    });


    return map;
  }

  async mounted() {

  }
}
